module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/412.dffd6487.png";